<template>
  <div class="container subscribe-page">
    <div class="loader" v-if="loading">
      <div class="load-spinner"></div>
    </div>
    <form>
      <h3>Pay now</h3>

      <label
        v-for="subscription in subscriptionsTypePQ"
        :key="subscription.id"
        :for="subscription.id"
        class="item"
        :class="{ checked: subscription.id == selectedSubscription }"
      >
        <input
          type="radio"
          name="item"
          :id="subscription.id"
          v-model="selectedSubscription"
          :value="subscription.id"
        />
        <img :src="storageUrl(subscription.image)" alt="" />
        <div class="details">
          <p>{{ subscription.name }}</p>
          <p>
            <span class="strikethrough"
              >₦ {{ (subscription.price / 100 + 200).toFixed(2) }}</span
            >
            ₦{{ (subscription.price / 100).toFixed(2) }}
          </p>
        </div>
      </label>

      <button type="button" :disabled="selectedSubscription == null">
        Total: ₦ {{ (totalAmount / 100).toFixed(2) }}
      </button>

      <button
        type="button"
        @click="payWithPaystack"
        :disabled="selectedSubscription == null"
      >
        Pay with Paystack
      </button>

      <button
        type="button"
        @click="payWithAirtime"
        :disabled="selectedSubscription == null"
      >
        Pay with Airtime
      </button>

      <button
        type="button"
        @click="payWithReferralBalance"
        :disabled="selectedSubscription == null"
      >
        Pay with Referral Balance
      </button>
    </form>
  </div>
</template>

<script>
import helpers from "@/mixins/helper";

export default {
  name: "PqSubscription",

  mixins: [helpers],

  data() {
    return {
      selectedSubscription: null,
      loading: false,
      totalAmount: 0
    };
  },

  watch: {
    selectedSubscription(subscription) {
      this.totalAmount = this.subscriptionsTypePQ
        .slice()
        .filter(sub => sub.id == subscription)[0].price;
    }
  },

  computed: {
    subscriptionsTypePQ() {
      return this.$store.state.subscriptions.filter(
        sub => sub.type == "past-question"
      );
    },

    studentActiveSubscriptions() {
      const activeSubscriptions = this.$store.getters[
        "student/activeSubscriptions"
      ];
      return activeSubscriptions;
    },

    user() {
      return this.$store.state.auth.user;
    }
  },

  created() {
    this.loadScript();
    this.fetchSubscriptions();
  },

  methods: {
    fetchSubscriptions() {
      if (this.$store.state.subscriptions.length < 1) {
        this.$store.dispatch("getSubscriptions");
      }

      if (this.$store.state.student.subscriptions.length < 1) {
        this.$store.dispatch("student/getSubscriptions");
      }
    },

    loadScript() {
      let script = document.createElement("script");
      script.setAttribute("src", "https://js.paystack.co/v1/inline.js");
      document.head.appendChild(script);
    },

    isSubscribedToSelectedSubscription(selected) {
      return this.studentActiveSubscriptions.filter(sub => sub.id == selected)
        .length;
    },

    payWithPaystack() {
      // check if user is not currently subscribe to selected subscription
      if (this.isSubscribedToSelectedSubscription(this.selectedSubscription)) {
        this.$store.commit("showAlert", {
          status: "danger",
          message: "You have an active subscription for this"
        });
        return;
      }

      if (window.PaystackPop == null) {
        this.loadScript();
        this.$store.commit("showAlert", {
          status: "danger",
          message: "Something went wrong. Please Try again"
        });
        return;
      }

      const vue = this;
      let handler = window.PaystackPop.setup({
        key: this.$store.state.PAYSTACK_PUBLIC_KEY,
        email: this.user.email,
        amount: this.totalAmount,
        firstname: this.user.first_name,
        lastname: this.user.last_name,
        metadata: {
          details: "Payment for Past question application",
          subscription_id: this.selectedSubscription
        },
        onClose: function() {
          vue.$store.commit("showAlert", {
            status: "danger",
            message: "Payment was not completed"
          });
        },
        callback: async function(response) {
          console.log("Callback", response);
          try {
            let verify = await vue.$store.dispatch(
              "verifyTransaction",
              response.reference
            );
            vue.$store.commit("showAlert", {
              status: verify.status || "success",
              message: verify.message
            });

            vue.$store.dispatch("student/getSubscriptions");
          } catch (error) {
            vue.$store.commit("showAlert", {
              status: "danger",
              message:
                error.response.data.message ||
                "An error occured. Please try again in few minutes"
            });
          }
          vue.$router.push("/student");
        }
      });
      handler.openIframe();
    },

    payWithAirtime() {},

    payWithReferralBalance() {}
  }
};
</script>
